const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
class FilterDrawer extends HTMLElement {
  constructor() {
    super();
    const filterButton = document.querySelectorAll(".js-toggle-filter");
    const filterDrawer = this.querySelector(".filter-drawer");
    const close = this.querySelector(".filter-header__close");
    const body = document.querySelector("body");
    body.addEventListener("click", (e) => {
      if (Array.from(filterButton).includes(e.target)) {
        filterDrawer.classList.remove("filter-drawer--hidden");
        bodyLock.lock();
      } else if (e.composedPath().includes(close)) {
        filterDrawer.classList.add("filter-drawer--hidden");
        bodyLock.unlock();
      } else if (e.composedPath().target === filterDrawer || e.composedPath().includes(filterDrawer)) {
        return;
      } else {
        bodyLock.unlock();
        filterDrawer.classList.add("filter-drawer--hidden");
      }
    });
    close.addEventListener("click", () => {
      bodyLock.unlock();
      filterDrawer.classList.add("filter-drawer--hidden");
    });
  }
}
if (customElements.get("filter-drawer") === void 0) {
  customElements.define("filter-drawer", FilterDrawer);
}
